// extracted by mini-css-extract-plugin
export var searchHeader = "_7t-0";
export var searchHeaderDark = "_7t-1";